import React from 'react'

const Spacer = _ => <div style={{flexBasis: "1%"}}/>
export default Spacer




/** WEBPACK FOOTER **
 ** ./app/components/Spacer.jsx
 **/